import React, { useState } from 'react';
import './App.css';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
// Ecosystem section removed
import ModulesSection from './components/ModulesSection';
import FAQSection from './components/FAQSection';
// Newsletter section removed
import Footer from './components/Footer';
import CategoryModal from './components/CategoryModal';
import CoursePage from './components/CoursePage';
import FeedbackPage from './components/FeedbackPage';

function App() {
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentPage, setCurrentPage] = useState('home'); // 'home', 'course', 'feedback'

  const handleStartCourse = () => {
    setShowCategoryModal(true);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setShowCategoryModal(false);
    setCurrentPage('course');
  };

  const handleBackToHome = () => {
    setCurrentPage('home');
    setSelectedCategory(null);
  };

  const handleCourseComplete = () => {
    setCurrentPage('feedback');
  };

  const handleFinish = () => {
    setCurrentPage('home');
    setSelectedCategory(null);
  };

  // Render Course Page
  if (currentPage === 'course' && selectedCategory) {
    return (
      <CoursePage
        category={selectedCategory}
        onBack={handleBackToHome}
        onComplete={handleCourseComplete}
      />
    );
  }

  // Render Feedback Page
  if (currentPage === 'feedback' && selectedCategory) {
    return (
      <FeedbackPage
        category={selectedCategory}
        onBack={() => setCurrentPage('course')}
        onFinish={handleFinish}
      />
    );
  }

  // Render Home Page
  return (
    <div className="App bg-[#FEF1CE] min-h-screen">
      <Header onStartCourse={handleStartCourse} />
      <HeroSection onStartCourse={handleStartCourse} />
      <ModulesSection onStartCourse={handleStartCourse} />
      <FAQSection />
      <Footer />
      
      <CategoryModal
        isOpen={showCategoryModal}
        onClose={() => setShowCategoryModal(false)}
        onSelectCategory={handleCategorySelect}
      />
    </div>
  );
}

export default App;
